import React, { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import PartnershipLabel from 'LuxKit/Label/PartnershipLabel'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import { VIRGIN_VELOCITY_PARTNERSHIP_CODE } from 'constants/partnerships'
import { getRewardPoints } from 'lib/partnership/partnershipUtils'

function isInvalid<T>(types: Array<T>, target: T): boolean {
  return types.length > 0 && !types.includes(target)
}

interface Props {
  className?: string;
  offer: App.Offer | App.OfferSummary;
  packagePartnership: App.PackagePartnership;
  price: number;
}

function OfferPackagePartnershipLabel(props: Props) {
  const {
    offer,
    className,
    price,
    packagePartnership,
  } = props

  const { partnership } = useContext(GeoContext)

  if (!partnership ||
    (partnership.availableForOfferType && isInvalid(partnership.availableForOfferType, offer.type)) ||
    (partnership.availableForProductType && isInvalid(partnership.availableForProductType, offer.productType) ||
      partnership.code === VIRGIN_VELOCITY_PARTNERSHIP_CODE
    )
  ) {
    return null
  }
  const points = getRewardPoints(packagePartnership, price)
  return (
    <LabelGroup>
      <PartnershipLabel
        className={className}
        points={points}
        variant="default"
      />
    </LabelGroup>
  )
}

export default React.memo(OfferPackagePartnershipLabel)
